var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.046875,12.9375 C1.46776039,9.98739221 2.28831494,6.32568237 4.9753792,4.33158492 C7.66244345,2.33748747 11.4048397,2.61298558 13.770927,4.97907295 C16.1370144,7.34516033 16.4125125,11.0875566 14.4184151,13.7746208 C12.4243176,16.4616851 8.76260779,17.2822396 5.8125,15.703125 L3.21,16.468125 C2.94676941,16.5454268 2.66233667,16.4728351 2.46834451,16.278843 C2.27435236,16.0848508 2.2017607,15.8004181 2.2790625,15.5371875 L3.046875,12.9375 Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.369375,7.5103125 C17.6739183,7.63560127 19.7547031,8.92965262 20.8861548,10.9412277 C22.0176064,12.9528028 22.0428658,15.4030266 20.953125,17.4375 L21.718125,20.04 C21.7954268,20.3032306 21.7228351,20.5876633 21.528843,20.7816555 C21.3348508,20.9756476 21.0504181,21.0482393 20.7871875,20.9709375 L18.1875,20.203125 C16.4496517,21.13252 14.3925777,21.256597 12.5556181,20.5428245 C10.7186584,19.829052 9.28503442,18.3486227 8.630625,16.4896875",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
var Memo = /*#__PURE__*/memo(SvgChat);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "_/_/packages/moonlight/lib/assets/icons/chat.2adef746b6ecbdc5c48cd1507089b633.svg";